import {useEffect, useState} from 'react';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {useDataTableBasic} from '@iamsoftware/react-hooks';

import {MessageService} from "../MessageService";

export const ConfigHistory = ({display, setDisplay}) => {

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (display) {
      MessageService.configHistory().then(({listData}) => {
        setItems(listData);
      });
    }
  }, [display]);

  const {render} = useDataTableBasic({
    columns: [
      {field: 'description', header: 'Cấu hình', width: 150, matchMode: 'contains'},
      {field: 'fromDate', header: 'Ngày hiệu lực', width: 150, dataType: 'date-time'},
    ],
    items
  });


  const footer = (
    <div>
      <Button label="Đóng" icon="pi pi-times" type="button" outlined severity="secondary" size="small" onClick={() => setDisplay(false)}/>
    </div>
  );
  const header = (
    <div>
      <h4> Lịch sử cấu hình</h4>
    </div>
  );

  return (
    <Dialog header={header} footer={footer} visible={!!display} style={{width: '60rem'}} position="top" onHide={() => setDisplay(false)}>
      {render()}
    </Dialog>
  );
}